import lockScroll from '../../../js/src/__utils/lockScroll';

const $ = jQuery.noConflict();

class Lightbox {
	constructor() {
		this.lightboxes = $('.component-lightbox');
		this.lightboxOpen = $('.component-lightbox__open');
		this.lightboxClose = $('.component-lightbox__close');
	}
	init() {
		this.bindEvents();
		this.lightboxes
			.find('.component-lightbox__container')
			.attr('style', null);
	}
	bindEvents() {
		this.lightboxOpen.on('click', this.openLightbox);
		this.lightboxClose.on('click', this.closeLightbox);
	}
	openLightbox(e) {
		e.preventDefault();
		const lightboxBlock = $(this).closest('.component-lightbox');

		let flag = 0;
		let el = $(e.target);
		let it = 0;
		while (flag === 0) {
			el.addClass('lightbox-modified-zindex');
			if ('page' === el[0].id || 100 === it) {
				flag = 1;
			}
			el = el.parent();
			it++;
		}

		lightboxBlock
			.find('.component-lightbox__container')
			.addClass('active')
			.attr('aria-hidden', false);
		if (lightboxBlock.find('.component-slider') && this.hash) {
			const slideNum = parseInt(this.hash.slice(1), 10);
			lightboxBlock
				.find('.component-slider')
				.slick('slickGoTo', slideNum, true);
		}
		if (
			e.currentTarget.getAttribute('data-embed-url') &&
			lightboxBlock.find('.component-lightbox__iframe')
		) {
			const embedUrl = e.currentTarget.getAttribute('data-embed-url');
			const ratio = e.currentTarget.getAttribute('data-ratio');
			const videoGallery = lightboxBlock.find(
				'.component-lightbox__iframe'
			);

			videoGallery.css('padding-top', `${ratio}%`);
			videoGallery.find('iframe').attr('src', embedUrl);
		}
		if (
			e.currentTarget.parentElement.classList.contains(
				'block-adventure-hero__slide'
			)
		) {
			const blockAdventureHeroBlock = document.querySelector(
				'.block-adventure-hero'
			);
			if (blockAdventureHeroBlock) {
				const iframeElements = blockAdventureHeroBlock.querySelectorAll('iframe');
				if (iframeElements.length > 0) {
					iframeElements.forEach((iframe) => {
						iframe.src = iframe.getAttribute('data-src');
					});
				}
			}
		}
		lockScroll.lock();
		$('body').addClass('lightbox-open');
	}
	// refreshSlider() {
	// 	this.lightboxes.slick('refresh');
	// }
	closeLightbox() {
		const lightboxBlock = $(this).closest('.component-lightbox');
		$('.lightbox-modified-zindex').removeClass('lightbox-modified-zindex');
		lightboxBlock
			.find('.component-lightbox__container')
			.removeClass('active')
			.attr('aria-hidden', true);

		const iframes = lightboxBlock.find('iframe');
		iframes.each(function (index) {
			const iframe = $(this);
			const src = iframe.attr('src');
			//console.log(src);
			iframe.attr('src', '').attr('src', src);
		});

		//lightboxBlock.find('iframe').attr('src', '').attr('src', src);
		lockScroll.unlock();
		$('body').removeClass('lightbox-open');
	}
}

const newLightbox = new Lightbox();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		newLightbox.init();
	},
	loaded() { },
	resized() { },
	scrolled() { },
	keyDown() { },
	mouseUp() { },
};
export default controller;
